import React from 'react'

export const ProfileScreen = () => {
    return (
        <div>
            <h1>Desde perfil</h1>
        </div>
    )
}
